import { LearnMoreLink } from './learn-more-link.model';

export const learnMoreLinks: LearnMoreLink[] = [
  {
    titleCode: 'preStarts',
    url: 'https://intercom.help/dashpivot/en/articles/2460839-prestarts-and-toolbox-talks',
  },
  {
    titleCode: 'methodStatements',
    url: 'https://intercom.help/dashpivot/en/articles/5098176-method-statements-swms-rams',
  },
  {
    titleCode: 'permits',
    url: 'https://intercom.help/dashpivot/en/articles/2460681-permits-safety',
  },
];
